import { InjectionToken } from '@angular/core';
export var DATA_SOURCE_SERVICE = new InjectionToken('DATA_SOURCE_SERVICE');
